// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__3px7Q","title":"Badge_title__3pz0v"};